(ns ui.components.select.async-select
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [oops.core :as oops]
   [reagent.core :as r]
   ["react-select" :default Select :refer (components)]
   ["react-select/async" :default AsyncSelect]
   ["react-select/async-creatable" :default AsyncCreatableSelect]
   ["react-select/creatable" :default CreatableSelect]
   ["react-window" :refer (FixedSizeList)]
   ["react-window-infinite-loader" :as ReactWindowInfiniteLoader]))

(def default-max-hits-per-page 50)
(def item-size 40)
(def min-menu-height item-size)
(def max-menu-height (* item-size 8))

(defn view
  [{:keys [is-multi?]}]
  (let [default-state {:search-term    ""
                       :options        []
                       :start-index    0
                       :has-next-page? true
                       :scroll-offset  0
                       :loading?       true}
        ;state-atom (r/atom default-state)
        ;scroll-offset-state (r/atom 0)
        ;should-focus-option-state (r/atom false)
        debug-state* (r/atom {})
        is-multi? (if (boolean? is-multi?)
                    is-multi?
                    false)]
    (fn
      [{:keys [value
               on-change
               create!
               disabled?
               get-options
               placeholder
               max-hits-per-page                                                                    ;; ??
               menu-placement
               auto-focus?
               block-scroll-on-menu-open?
               is-clearable?
               on-menu-close!
               on-menu-open!
               is-loading?
               open-menu-on-focus?
               menu-portal-target]}]
      ;; TODO - remove when debug done
      (assert
       (if is-multi?
         (or (empty? value)
             (->> value
                  (every? (fn [opt]
                            (= [:value :label]
                               (keys (select-keys opt [:value :label])))))))
         (or (nil? value)
             (= [:value :label]
                (keys (select-keys value [:value :label]))))))

      (let [max-hits-per-page (or max-hits-per-page default-max-hits-per-page)
            creatable? (fn? create!)]
        [:>
         (if creatable?
           AsyncCreatableSelect
           AsyncSelect)
         (merge {:value                 (clj->js value)
                 :menuPortalTarget      (or menu-portal-target
                                            (.-body js/document))
                 ;; TODO -> confirm we want to have this fixed
                 :menuPosition          "fixed"                                                     ;; fixed | absolute
                 :classNames            {:menuPortal       (constantly "z-[40000000]")
                                         :multiValue       (constantly "bg-complement-regular text-complement-regular-text")
                                         :multiValueRemove (constantly "bg-complement-regular text-complement-regular-text")
                                         :control          (constantly "pl-2 min-h-10 bg-input-light text-input-light-text border border-solid border-input-light-border-paler hover:border-input-light-border focus:border-input-light-border outline-none shadow-none")
                                         :menu             (constantly "z-[40000000] bg-input-light")
                                         :option           (constantly "text-input-light-text bg-input-light hover:bg-input-gloomy hover:text-input-gloomy-text")
                                         :valueContainer   (when is-multi?
                                                             (constantly "gap-1 p-0 *:p-0"))
                                         :multiValueLabel  (constantly "bg-complement-gloomy text-complement-regular-text")}
                 :onMenuClose           (fn []
                                          ;(reset! state-atom default-state)
                                          ;(reset! scroll-offset-state 0)
                                          ;(reset! should-focus-option-state false)
                                          (when (fn? on-menu-close!)
                                            (on-menu-close!)))
                 :onMenuOpen            (fn [& _args]
                                          (when (fn? on-menu-open!)
                                            (on-menu-open!)))
                 :isDisabled            disabled?
                 :filterOption          (fn [js-args]
                                          ;; filter out selected options so that they are not shown in dropdown
                                          (let [opt-value (oops/oget js-args "value")]
                                            (if-not is-multi?
                                              true                                                  ;; all options for single select
                                              (or (empty? value)
                                                  ;; TODO - if value has many selections - using set could be faster
                                                  (not-any? #{opt-value} value)))))
                 :isLoading             is-loading?
                 :isMulti               is-multi?
                 :isClearable           is-clearable?
                 :autoFocus             auto-focus?
                 :openMenuOnFocus       (boolean open-menu-on-focus?)
                 :createOptionPosition  "first"
                 :placeholder           (or placeholder "")
                 :menuShouldBlockScroll (if (boolean? block-scroll-on-menu-open?)
                                          block-scroll-on-menu-open?
                                          true)
                 :onCreateOption        (fn [query]
                                          (when (fn? create!)
                                            (create! (string/trim query))))
                 :noOptionsMessage      (fn []
                                          (loc/tr :no-options))
                 ; Todo fix view jumping when opening near bottom of screen
                 :menuPlacement         (or menu-placement "auto")

                 :defaultOptions        true
                 ;; this is the beef for async loading -> this is called already on first render when ^^ defaultOptions is true
                 :loadOptions           (fn [query callback]
                                          (get-options query
                                                       (fn [resp]
                                                         (let [resp (->> resp
                                                                         (mapv (fn [o]
                                                                                 (select-keys o [:value :label]))))
                                                               js-resp (clj->js resp)]
                                                           (try
                                                             (callback js-resp)
                                                             (catch js/Object o
                                                               (js/console.log "Failed to call getOptions callback")
                                                               (js/console.log o))))))
                                          ;; Do not return promise as loadOptions will work differently depending on th return value
                                          nil)
                 ;; TODO : FIX ME
                 :onChange              (fn [js-val _js-opts]
                                          (let [selected-options (js->clj js-val :keywordize-keys true)
                                                selected-values (if is-multi?
                                                                  (->> selected-options
                                                                       (mapv :value))
                                                                  (:value selected-options))]
                                            (on-change selected-values selected-options)))
                 :components
                 {:LoadingMessage (r/reactify-component
                                   (fn [{:keys [] :as props}]
                                     [:> (.-LoadingMessage components)
                                      props
                                      [:div
                                       {:class "flex flex-row"}
                                       (loc/tr :loading)]]))
                  :SingleValue    (r/reactify-component
                                   (fn [{:keys [children data selectProps] :as props}]
                                     (let [_domain (aget data "secondaryLabel")]
                                       [:> (.-SingleValue components)
                                        props
                                        [:div
                                         {:class "flex flex-row items-center"}
                                         (if (aget selectProps "menuIsOpen")
                                           ""
                                           children)]])))
                  #_:Input          #_(r/reactify-component
                                   (fn [props]
                                     [:> (.-Input components)
                                      (merge (js->clj props :keywordize-keys true)
                                             {:onKeyDown (fn [e]
                                                           (let [ctrlKey (aget e "ctrlKey")
                                                                 o? (= "o" (aget e "key"))]
                                                             (when (and ctrlKey o?)
                                                               (swap! debug-state* assoc :force-menu-open? (not (:force-menu-open? @debug-state*))))))})]))
                  #_:MultiValueLabel #_(r/reactify-component
                                        (fn [{:keys [data innerProps selectProps children] :as props}]
                                          [:> (.-MultiValueLabel components)
                                           props
                                           [:div
                                            {:class "flex flex-row items-center"}
                                            children]]))
                  #_:MultiValue  #_(r/reactify-component
                                    (fn [props]
                                      (let [js-data (:data props)
                                            options (:options props)
                                            data (js->clj js-data :keywordize-keys true)
                                            label (or (and (map? data)
                                                           (:label data))
                                                      (->> options
                                                           (keep (fn [js-opt]
                                                                   (let [opt (js->clj js-opt :keywordize-keys true)]
                                                                     (when (= (:value opt) data)
                                                                       (:label opt)))))
                                                           (first)))]
                                        [:> (.-SingleValue components)
                                         props
                                         [:div
                                          {:class "flex flex-row items-center
                               text-sm
                                border rounded
                               pr-2 pl-2
                               bg-complement-regular text-complement-regular-text"}
                                          label]])))
                  #_:Option          #_(r/reactify-component
                                        (fn [props]
                                          (let [js-data (:data props)
                                                {:keys [icon value label] :as data} (js->clj js-data :keywordize-keys true)]
                                            [:> (.-Option components)
                                             props
                                             [:div
                                              {:class "flex flex-row gap-2 items-center justify-items-center"}
                                              (when icon
                                                ;[tooltip/view
                                                [:i.fal
                                                 {:class icon}]
                                                #_[:div
                                                   {:class "max-w-40"}
                                                   "long sample tooltip text that can span over multiple elements within the menu dropdown - does it work ?"]
                                                ;]
                                                )
                                              label]])))
                  #_:MenuList
                  #_(r/reactify-component
                     (fn [{:keys [options children focusedOption] :as menu-list-props}]
                       (let [option-count (or (.-length children) 0)
                             menu-height (min (max (* option-count item-size) min-menu-height) max-menu-height)

                             is-item-loaded (fn [i]
                                              (< i (count options)))
                             no-options (fn []
                                          (and (not (:loading? @state-atom))
                                               (= option-count 0)))
                             has-next-page? (:has-next-page? @state-atom)
                             item-count (if has-next-page?
                                          (+ option-count 1)
                                          option-count)]
                         [:div
                          [:> ReactWindowInfiniteLoader
                           {:isItemLoaded is-item-loaded
                            :itemCount    item-count
                            :threshold    2
                            :loadMoreItems
                            (fn []
                              (let [start-index (:start-index @state-atom)
                                    search-term (:search-term @state-atom)
                                    previous-options (:options @state-atom)]
                                (-> (get-options {:search-term       search-term
                                                  :start-index       start-index
                                                  :max-hits-per-page max-hits-per-page})
                                    (p/then (fn [{:keys [options has-next-page?]}]

                                              (swap! state-atom assoc :loading? false)

                                              (let [new-options (vec (concat previous-options options))]
                                                (swap! state-atom assoc :options new-options)
                                                (swap! state-atom assoc :has-next-page? has-next-page?)
                                                (swap! state-atom assoc :start-index (+ start-index max-hits-per-page)))))
                                    (p/catch
                                     (fn []
                                       (swap! state-atom assoc :loading? false))))))}
                           (fn [list-js-props]
                             (r/as-element
                              [:> FixedSizeList
                               {:height              menu-height
                                :itemCount           item-count
                                :itemSize            item-size
                                :onItemsRendered     (.-onItemsRendered list-js-props)
                                :ref                 (fn [dom-node]
                                                       (when (and dom-node @should-focus-option-state)
                                                         (->> focusedOption
                                                              (.indexOf options)
                                                              (.scrollToItem dom-node))
                                                         (reset! should-focus-option-state false))
                                                       ((.-ref list-js-props) dom-node))
                                :initialScrollOffset @scroll-offset-state
                                :onScroll            (fn [js-event]
                                                       (let [scroll-offset (.-scrollOffset js-event)
                                                             scroll-direction (.-scrollDirection js-event)]
                                                         (when-not (and (= scroll-direction "forward")
                                                                        (= scroll-offset 0))
                                                           (reset! scroll-offset-state scroll-offset))))}
                               (fn [item-js-props]
                                 (let [style (.-style item-js-props)
                                       index (.-index item-js-props)]
                                   (r/as-element [:div
                                                  {:style style}
                                                  (cond
                                                    (no-options)
                                                    [:div
                                                     {:class (h/<class style/loading)}
                                                     "No results"]

                                                    (is-item-loaded index)
                                                    (get children index)

                                                    :else
                                                    [:div
                                                     {:class (h/<class style/loading)}
                                                     "Loading..."])])))]))]])))}
                 ;:onKeyDown             #(reset! should-focus-option-state true)
                 ;:onKeyUp               #(reset! should-focus-option-state true)
                 #_:onKeyDown             #_(fn [k]
                                          (let [{:keys [ctrlKey key]} (js->clj k :keywordize-keys true)]
                                            (when (and ctrlKey
                                                       (= key "o"))
                                              (js/console.log "Force open : " key)
                                              (swap! debug-state* assoc :force-menu-open? (not (:force-menu-open? @debug-state*))))))}
                #_(when (true? (:force-menu-open? @debug-state*))
                  (js/console.log "Forced open : " @debug-state*)
                  {:menuIsOpen true}))
         ]))))
